import { VueConstructor } from "vue";
import clickOutside from "@/directives/click-outside";
import Tooltip from "primevue/tooltip";
import Ripple from "vue-material-design-ripple";
import "vue-material-design-ripple/dist/vue-material-design-ripple.css";
import NoContextMenu from "@/directives/PreventContenxtMenu";
export default {
  install(Vue: VueConstructor) {
    Vue.directive("ripple", Ripple);
    Vue.directive("click-outside", clickOutside);
    Vue.directive("tooltip", Tooltip);
    Vue.directive("NoContextMenu", NoContextMenu);
  }
};
